import { render, staticRenderFns } from "./newDetails.vue?vue&type=template&id=3b436130&scoped=true"
import script from "./newDetails.vue?vue&type=script&lang=js"
export * from "./newDetails.vue?vue&type=script&lang=js"
import style0 from "./newDetails.vue?vue&type=style&index=0&id=3b436130&prod&scoped=true&lang=css"
import style1 from "./newDetails.vue?vue&type=style&index=1&id=3b436130&prod&lang=css"
import style2 from "./newDetails.vue?vue&type=style&index=2&id=3b436130&prod&scoped=true&lang=css"
import style3 from "./newDetails.vue?vue&type=style&index=3&id=3b436130&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b436130",
  null
  
)

export default component.exports